import { useCallback } from 'react';

import { useHandleOpenGraph } from './useHandleOpenGraph';

export const useShare = ({
  url = '',
  title = '',
  text = '',
  imageUrl = '',
  ...props
}) => {
  useHandleOpenGraph({
    title,
    description: text,
    url,
    imageUrl,
  });

  const { createKakaoShareButton } = useShareKakao({
    url,
    text,
    title,
    imageUrl,
    ...props,
  });

  const naverShareURL = `https://share.naver.com/web/shareView?url=${encodeURIComponent(
    url,
  )}&title=${encodeURIComponent(title)}`;

  const twitterShareURL = `https://twitter.com/intent/tweet?&text=${encodeURIComponent(
    text,
  )}&url=${encodeURIComponent(url)}`;

  const facebookShareURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url,
  )}`;

  const naverBandShareURL = `https://band.us/plugin/share?body=${encodeURIComponent(
    `${text}\n\n${url}`,
  )}`;

  const shareSNS = (sns) => {
    if (sns.includes('kakao')) {
      createKakaoShareButton({ type: sns });
    } else {
      const shareURL = {
        naver: naverShareURL,
        twitter: twitterShareURL,
        facebook: facebookShareURL,
        naverBand: naverBandShareURL,
      };
      const popup = window.open(
        shareURL[sns],
        '_blank',
        'width=460,height=720',
      );
      !popup && alert('차단된 팝업을 해제해주세요.');
    }
  };

  return { shareSNS };
};

export const useShareKakao = ({
  url = '',
  text = '',
  title = '',
  imageUrl = '',
  ...props
}) => {
  const createKakaoShareButton = useCallback(
    ({ type }) => {
      if (window.Kakao) {
        const kakao = window.Kakao;
        if (!kakao.isInitialized()) {
          kakao.init(process.env.REACT_APP_KAKAO_KEY);
        }
        if (type === 'kakaoStory') {
          kakao.Story.share({
            url,
            text,
          });
        }
        if (type === 'kakaoTalk') {
          kakao.Link.sendDefault({
            objectType: 'feed',
            content: {
              title,
              description: text,
              imageUrl,
              link: {
                mobileWebUrl: url,
                webUrl: url,
              },
            },
            ...props,
          });
        }
      }
    },
    [url, text, title, imageUrl],
  );

  return { createKakaoShareButton };
};
